export default "__VITE_ASSET__JxQfg9yK__"